import { DictionaryContext } from '../../providers'
import { toast, ToastOptions, ToastVariant } from '../../store/toastStore'
import { useContext } from 'react'

export interface ToastTranslationKeys {
    PENDING?: string
    SUCCESS?: string
    FAILURE?: string
}

export interface UseStatusToastOptions {
    translationKeys: ToastTranslationKeys
}

export interface UseStatusToastReturn {
    open: (customMessage?: string) => void
    succeed: (customMessage?: string, options?: Omit<ToastOptions, 'translationKeys' | 'message'>) => void
    fail: (customMessage?: string, options?: Omit<ToastOptions, 'translationKeys' | 'message'>) => void
    hide: () => void
}

export const useStatusToast = ({ translationKeys }: UseStatusToastOptions): UseStatusToastReturn => {
    const dictionary = useContext(DictionaryContext)

    const open = (customMessage?: string): void => {
        const key = translationKeys.PENDING
        const message = customMessage ?? (key ? dictionary?.getText(key) ?? '' : '')
        toast.show({ message: message ?? '', variant: ToastVariant.LOADING })
    }

    const succeed = (customMessage?: string, options?: Omit<ToastOptions, 'translationKeys' | 'message'>): void => {
        const key = translationKeys.SUCCESS
        const message = customMessage ?? (key ? dictionary?.getText(key) ?? '' : '')
        toast.show({ message: message ?? '', variant: ToastVariant.SUCCESS, ...options })
    }

    const fail = (customMessage?: string, options?: Omit<ToastOptions, 'translationKeys' | 'message'>): void => {
        const key = translationKeys.FAILURE
        const message = customMessage ?? (key ? dictionary?.getText(key) ?? '' : '')
        toast.show({ message: message ?? '', variant: ToastVariant.ERROR, ...options })
    }

    const hide = (): void => {
        toast.dismiss()
    }

    return { open, succeed, fail, hide }
}
